import CommonLandingContainer, {
  LandingHorizontalBlock,
} from 'src/components/landingComponents/containers/common';

import styles from './giga.module.scss';
import { Body, Button } from 'src/components/landingComponents/typography';
import LandingButton from 'src/components/landingComponents/button';
import api from 'src/Api/service';
import { Box, TextField } from '@mui/material';
import { useState } from 'react';
import PendingRows from 'src/components/ui/pendingRows';

const Giga = () => {
  const [question, setQuestion] = useState('');
  const [prompt, setPrompt] = useState('');
  const [temp, setTemp] = useState('0.87');
  const [topP, setTopP] = useState('0.47');
  const [maxTokens, setMaxTokens] = useState('512');
  const [result, setResult] = useState();
  const [inProgress, setInProgress] = useState(false);

  const onSubmit = async () => {
    setInProgress(true);
    const result = await api('landing/gigaRequest', {
      messages: [
        { role: 'system', message: prompt },
        { role: 'user', message: question },
      ],
      temperature: temp ?? '0.87',
      topP: topP ?? '0.47',
      maxTokens: maxTokens ?? '512',
    });
    setResult(result?.data ?? result?.errors?.[0]?.message?.message);
    setInProgress(false);
  };

  return (
    <>
      <LandingHorizontalBlock id="greeting" className={styles.firstBlock}>
        <CommonLandingContainer>
          <Box p={2}>
            <TextField
              fullWidth
              id="temperature"
              label="temperature"
              variant="standard"
              value={temp}
              onChange={(event) => {
                setTemp(event.target.value);
              }}
            />
            <br />
            <br />
            <Body>
              Температура выборки. Чем выше значение, тем более случайным будет
              ответ модели. Если значение температуры находится в диапазоне от 0
              до 0.001, параметры temperature и top_p будут сброшены в режим,
              обеспечивающий максимально детерминированный (стабильный) ответ
              модели. При значениях температуры больше двух, набор токенов в
              ответе модели может отличаться избыточной случайностью.
            </Body>
          </Box>
          <Box p={2}>
            <TextField
              fullWidth
              id="top_p"
              label="top_p"
              variant="standard"
              value={topP}
              onChange={(event) => {
                setTopP(event.target.value);
              }}
            />
            <br />
            <br />
            <Body
              className={styles.hint}
            >{`Параметр используется как альтернатива температуре (поле temperature). Задает вероятностную массу токенов, которые должна учитывать модель. Так, если передать значение 0.1, модель будет учитывать только токены, чья вероятностная масса входит в верхние 10%.
Возможные значения: >= 0 и <= 1`}</Body>
          </Box>
          <Box p={2}>
            <TextField
              fullWidth
              id="max_tokens"
              label="max_tokens"
              variant="standard"
              value={maxTokens}
              onChange={(event) => {
                setMaxTokens(event.target.value);
              }}
            />
            <br />
            <br />
            <Body className={styles.hint}>
              Максимальное количество токенов, которые будут использованы для
              создания ответов.
            </Body>
          </Box>
          <Box p={2}>
            <br />
            <TextField
              fullWidth
              id="prompt"
              placeholder="Промпт настройки (роль system)"
              multiline
              minRows={2}
              variant="standard"
              value={prompt}
              onChange={(event) => {
                setPrompt(event.target.value);
              }}
            />
          </Box>
          <Box p={2}>
            <br />
            <TextField
              fullWidth
              id="question"
              placeholder="Текст запроса (роль user)"
              multiline
              minRows={2}
              variant="standard"
              value={question}
              onChange={(event) => {
                setQuestion(event.target.value);
              }}
            />
          </Box>

          <Box p={2}>
            {!inProgress && (
              <LandingButton
                variant="contained"
                onClick={onSubmit}
                disabled={!question}
              >
                <Button>Мне только спросить</Button>
              </LandingButton>
            )}
            {inProgress && <PendingRows count={1} inProgress={inProgress} />}
          </Box>
          <Box p={2}>
            <Body className={styles.hint}>Ответ:</Body>
            <TextField
              fullWidth
              id="question"
              // pla="Ответ"
              multiline
              minRows={2}
              variant="standard"
              value={result}
              readOnly
            />
          </Box>
        </CommonLandingContainer>
      </LandingHorizontalBlock>
    </>
  );
};

export default Giga;
